class CommCodeModel {

    constructor(commCode) {

        const {
            commCd,
            commCdName,
        } = commCode;

        this.label = commCdName;
        this.value = commCd;

    }

}

export default CommCodeModel;